import React from 'react';
import { Navigate } from 'react-router-dom';
import AdminLayout from '../../../components/AdminLayout';
import ContentBox from '../../../components/ContentBox';

function UsersAdmin({ userData }) {
    if (!userData || !userData.hasAdminRole) {
        return <Navigate to="/" replace />;
    }

    return (
        <AdminLayout>
            <ContentBox theme="default" tint="red" header="Moderate Users">
                <p className="mb-4">So we can slap naughty boys, girls, they, thems</p>
            </ContentBox>
        </AdminLayout>
    );
}

export default UsersAdmin;